(function () {
  var tracks = document.querySelectorAll('.beaglex-reviews__track');

  tracks.forEach(function (track) {
    var wrap = track.closest('.beaglex-reviews__inner');
    if (!wrap) return;

    var cards = track.querySelectorAll('[data-review-card]');
    var dots = wrap.querySelectorAll('[data-review-dot]');
    var prevBtn = wrap.querySelector('[data-review-prev]');
    var nextBtn = wrap.querySelector('[data-review-next]');
    if (!cards.length) return;

    function scrollToIndex(index) {
      var card = cards[index];
      if (card) {
        card.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
      }
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        scrollToIndex(parseInt(dot.getAttribute('data-review-dot'), 10));
      });
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        var step = cards[0].getBoundingClientRect().width + 16;
        track.scrollBy({ left: -step, behavior: 'smooth' });
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        var step = cards[0].getBoundingClientRect().width + 16;
        track.scrollBy({ left: step, behavior: 'smooth' });
      });
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              var index = Array.prototype.indexOf.call(cards, entry.target);
              dots.forEach(function (dot, i) {
                var active = i === index;
                dot.classList.toggle('is-active', active);
                dot.setAttribute('aria-selected', active ? 'true' : 'false');
              });
              if (prevBtn) prevBtn.disabled = index === 0;
              if (nextBtn) nextBtn.disabled = index === cards.length - 1;
            }
          });
        },
        { root: track, threshold: 0.6 }
      );
      cards.forEach(function (card) {
        observer.observe(card);
      });
    }
  });
})();
